<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>

  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(images/background/14.jpg)"
    data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Contact Us</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <section id="section-contact" data-bgcolor="#f9f9f9">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div>


            <h3 class="id-color">DGT</h3>
            <!-- <h4> Karol Bagh Office </h4>
              <p> Ministry of Skill Development and Entrepreneurship,</p>
              <p> Kaushal Bhawan,B-2,Pusa Road, </p>
              <p> Near Karol Bagh Metro Station,Pillar No.95 </p>
              <p> New Delhi, Delhi 110001 </p> -->

            <!-- <h4 class="id-color">Pusa Office</h4>
              <h4> Directorate General of Training,</h4> -->
            <p>
              Directorate General of Training <br />
              CIRTES Building,Pusa, <br />
              (Beside ITI Pusa), <br />
              New Delhi, Delhi 110012
            </p>

            <h4 class="id-color">For Enquiries</h4>

            <p>
              Affliliation Matters :011-25847026 extn.122/123 <br />
              Apprenticeship :011-25847023 <br />
              Exam Related :011-25847031 <br />
              Deputy Director General :011-25847035 <br />
              Director General :011-25731103 <br />
              Email - dirgen-msde@gov.in <br>
              website: <a target="_blank" href="https://dgt.gov.in/"> dgt.gov.in </a><br><br>
            </p>

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7003.556596329374!2d77.168096!3d28.636406000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4a46ec4dd6ed0c86!2sDGT%20Head%20Quarters%20(Directorate%20General%20of%20Training!5e0!3m2!1sen!2sin!4v1616760835823!5m2!1sen!2sin"
              width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

          </div>
        </div>
        <div class="col-md-4">
          <!-- <div class="spacer-single"></div> -->
          <h3 class="id-color">CSTARI</h3>
          <p>
            Central Staff Training and Research Institute <br />
            EN-Block, Salt Lake, Sector V, <br />
            Kolkata, <br />
            West Bengal 700091
          </p>

          <h4 class="id-color">For Enquiries</h4>

          <p>
             DIRECTOR <br />

            Phone – 033-2357-2210 Fax – 033-2357-1005 <br />

            Email - cstarikol-wb@nic.in
          </p>
          <p>
            C. S. Murthy, JDT/HOO <br />

            Phone – 033-2357-2239 <br />

            Email - murthychs@hotmail.com <br>
            website: <a target="_blank" href="http://www.cstaricalcutta.gov.in/"> cstaricalcutta.gov.in </a>
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.086433682356!2d88.42733301529081!3d22.575870385181112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0275b00d2d505f%3A0x5b3d0bec1ff51986!2sCentral%20Staff%20Training%20and%20Research%20Institute!5e0!3m2!1sen!2sin!4v1617096456072!5m2!1sen!2sin"
            width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>


        </div>
        <div class="col-md-4">
          <!-- <div class="spacer-single"></div> -->
          <h3 class="id-color">NIMI</h3>
          <p>
            National Instructional Media Institute <br />
            Post Box No. 3142 , CTI Campus <br />

            Guindy Industrial Estate, Guindy <br />
            Chennai - 600 032.
          </p>
          <h4 class="id-color">For Enquiries</h4>

          <p>
            Executive Director : 044 - 2250 0657 <br />

            Sales : 044 - 2250 0248 <br />

            Marketing : 044 - 2250 2421 <br />

            Fax : 044 - 2250 0791 <br />
            Email - nimirecruitment@gmail.com <br>
            website: <a target="_blank" href="https://nimi.gov.in/index.htm">nimi.gov.in </a> <br><br><br>
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7774.739595033338!2d80.214896!3d13.012107!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x384bc742d2c39e64!2sNational%20Instructional%20Media%20Institute(NIMI)!5e0!3m2!1sen!2sin!4v1617000093192!5m2!1sen!2sin"
            width="100%" height="200" style="border: 0" allowfullscreen="" loading="lazy"></iframe>

        </div>
      </div>

    </div>
  </section>